import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const ImagePreviewModal = ({
    isOpen,
    onClose,
    imageUrl,
    title,
}) => (
    <Modal
        isOpen={isOpen}
        toggle={onClose}
        centered
        size="xl"
        className="asset-image-preview-modal"
    >
        <ModalHeader toggle={onClose}>
            {title || "Asset Image"}
        </ModalHeader>
        <ModalBody
            className="text-center"
            style={{
                background: "#0f172a",
                minHeight: "78vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "1rem",
            }}
        >
            {imageUrl ? (
                <div className="w-100">
                    <img
                        src={imageUrl}
                        alt={title || "Asset Image"}
                        style={{
                            width: "100%",
                            maxHeight: "72vh",
                            objectFit: "contain",
                            borderRadius: "1rem",
                            background: "#020617",
                        }}
                    />
                    <div className="text-white-50 small mt-3">
                        Previewing the current image
                    </div>
                </div>
            ) : (
                <div className="text-muted">No image available.</div>
            )}
        </ModalBody>
    </Modal>
);

export default ImagePreviewModal;
